import _ from "lodash";

/**
 * Generate a random color, util for see when a component renders
 *
 * <div style={{backgroundColor: randomColour()}}>
 *   <YourComponent />
 * </div>
 *
 * @returns {string}
 */
export function randomColor() {
  return '#'+(Math.random()*0xFFFFFF<<0).toString(16);
}

export function showOrHide(value) {
  const parsed = String(value).replace( /[\D]+/g, ''); // replace non digit values

  return _.gt(_.toNumber(parsed), 0);
}
